export class ProdutoFornecedorValor{
  idProduto: number;
  idFornecedor: number;
  descricaoFornecedor: string;
  precoCusto: number;
  precoVenda: number;
  precoAvulso: number;
  qtEstoque: number;
  qtTrava: number;
  margemPrecoVenda: number;
  margemPrecoAvulso: number;
  cmv: number;
  descComplementar: string;
  dtDisponibilidade: Date;
  situacao: string;
  qtReserva: number;
}
